import {
  LAYER_TYPES,
  LAYER_SUBTYPES,
  PROP_DATA_TYPE,
  GEOJSON_GEOMETRIES
} from '../../../../api/Layers/Layers';

export default [
  {
    name: 'Catastro Whatever',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/CATASTRO/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=CATASTRO:superunionpp&outputFormat=application/json&CQL_FILTER=estado>0`,
    attribution: 'Generic attribution',
    geojsonProps: [
      {
        name: 'nameunit',
        max: 'Ólvega',
        min: 'Abarca de Campos',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'estado',
        max: '5',
        min: '1',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'fuente_principal',
        max: '2',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'bbox',
        max: '-7.0771,42.4933,-6.8938,42.592',
        min: '-1.8737,41.8184,-1.8176,41.8654',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    styleId: 'Simple Orange Polygon',
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Spain Provinces',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url:
      'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/spain-provinces.geojson',
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/poblacion.9e953ece.png',
    geojsonProps: [
      {
        name: 'cod_prov',
        max: '52',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'name',
        max: 'Ávila',
        min: 'A Coruña',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cod_ccaa',
        max: '19',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cartodb_id',
        max: 52,
        min: 1,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'created_at',
        max: '2014-09-30T00:00:00Z',
        min: '2014-09-30T00:00:00Z',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'updated_at',
        max: '2014-12-25T01:56:10Z',
        min: '2014-12-25T01:56:10Z',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    styleId: 'Simple Orange Polygon',
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Madrid SouthEast Streets',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Madrid/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Madrid:ViaUrbana&outputFormat=application/json`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/04__.png',
    geojsonProps: [
      {
        name: 'cod_prov',
        max: '52',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'name',
        max: 'Ávila',
        min: 'A Coruña',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cod_ccaa',
        max: '19',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cartodb_id',
        max: 52,
        min: 1,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'created_at',
        max: '2014-09-30T00:00:00Z',
        min: '2014-09-30T00:00:00Z',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'updated_at',
        max: '2014-12-25T01:56:10Z',
        min: '2014-12-25T01:56:10Z',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.LINESTRING,
    styleId: 'Madrid SouthEast Streets',
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Prueba Puntos GeoJSON',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    attribution: 'Generic attribution',
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_victimas_centroid&outputFormat=application/json`,
    geojsonProps: [
      {
        name: 'fid',
        max: 18,
        min: 0,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'nameunit',
        max: 'Rioja, La',
        min: 'Andalucía',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'te_victimas_2017',
        max: 6982,
        min: 74,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'years_0_18_victimas_2017',
        max: 151,
        min: 0,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'years_18_24_victimas_2017',
        max: 1006,
        min: 13,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'years_25_44_victimas_2017',
        max: 4253,
        min: 47,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'years_45_64_victimas_2017',
        max: 1437,
        min: 8,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'years_mas65_victimas_2017',
        max: 135,
        min: 0,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '2.911780802,39.573969928,2.911780802,39.573969928',
        min: '-0.553542675,39.401227459,-0.553542675,39.401227459',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Prueba Puntos GeoJSON',
    geojsonGeometry: GEOJSON_GEOMETRIES.POINT,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Numeric Categorized',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    attribution: 'Generic attribution',
    url: `https://geoserver.ipsilum.com/geoserver/CATASTRO/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=CATASTRO:superunionpp&outputFormat=application/json&CQL_FILTER=estado>0`,
    geojsonProps: [
      {
        name: 'nameunit',
        max: 'Ólvega',
        min: 'Abarca de Campos',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'estado',
        max: '5',
        min: '1',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'fuente_principal',
        max: '2',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'bbox',
        max: '-7.0771,42.4933,-6.8938,42.592',
        min: '-1.8737,41.8184,-1.8176,41.8654',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Numeric Categorized',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Paro en España por Provincias Discreto',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Pruebacambio/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Pruebacambio:superunion&outputFormat=application/json`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/poblacion.9e953ece.png',
    geojsonProps: [
      {
        name: 'cod_prov',
        max: '9',
        min: '1',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cod_ccaa',
        max: '19',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'paro',
        max: 100,
        min: 1,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'aleatorio',
        max: '99',
        min: '1',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'bbox',
        max: '1.7243,41.65,3.3326,42.4948',
        min: '-0.8463,39.7147,0.6911,40.7886',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Paro en España por Provincias Discreto',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Limpieza por Distritos 2018',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,kg_recogida_total_2018,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'kg_recogida_total_2018',
        max: 4475942,
        min: 748419.44,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Limpieza por Distritos 2018',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Limpieza por Distritos 2017',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,kg_recogida_total_2017,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'kg_recogida_total_2017',
        max: 6075992.5,
        min: 549258.6,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Limpieza por Distritos 2017',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Incremento Recogida',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_recog,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'incr_recog',
        max: 239138.88,
        min: -2882100.5,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Incremento Recogida',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Servicios Limpieza 2018',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,n_servicios_total_2018,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'n_servicios_total_2018',
        max: 30127,
        min: 3827,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Servicios Limpieza 2018',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Servicios Limpieza 2017',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,n_servicios_total_2017,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'n_servicios_total_2017',
        max: 30956,
        min: 3509,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Servicios Limpieza 2017',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  },
  {
    name: 'Incremento Servicios',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_num_servic,geom`,
    attribution: 'Generic attribution',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/limpieza.a087a164.png',
    geojsonProps: [
      {
        name: 'nombre',
        max: 'Villaverde',
        min: 'Arganzuela',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'incr_num_servic',
        max: 1664,
        min: -4465.022,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'bbox',
        max: '-3.88896199,40.468514115,-3.601794213,40.643270667',
        min: '-3.627939136,40.446557582,-3.524864453,40.512404677',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    styleId: 'Incremento Servicios',
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    minZoom: 0,
    maxZoom: 20,
    isFeature: 'False',
    mapLocation: {
      type: 'Feature',
      properties: {
        zoom: 5
      },
      geometry: {
        type: 'Point',
        coordinates: [-6.9167185, 36.1297110870542]
      },
      bbox: [-47.52218725, 17.0051017340419, 33.68875025, 51.5297977856241]
    }
  }
];
